module.exports = __webpack_public_path__ + "img/thumb_30.ef04ee9f.jpg";